import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

const Welcome = () => import(/* webpackChunkName: "view-Welcome" */ './views/Welcome.vue')
const Login = () => import(/* webpackChunkName: "component-WelcomeLogin" */ './components/Welcome/Login.vue')
const EmailVerification = () => import(/* webpackChunkName: "component-WelcomeEmailVerification" */ './components/Welcome/EmailVerification.vue')
const Activation = () => import(/* webpackChunkName: "component-WelcomeActivation" */ './components/Welcome/Activation.vue')

const MainLayout = () => import(/* webpackChunkName: "view-MainLayout" */ './views/MainLayout.vue')
const Dashboard = () => import(/* webpackChunkName: "view-Dashboard" */ './views/Dashboard.vue')
const OrderDetail = () => import(/* webpackChunkName: "component-DashboardOrderDetail" */ './components/Dashboard/OrderDetail/index.vue')
const Orders = () => import(/* webpackChunkName: "view-Orders" */ './views/Orders.vue')

const Parameter = () => import(/* webpackChunkName: "view-Customer" */ './views/Parameter.vue')
const ParameterList = () => import(/* webpackChunkName: "component-CustomerList" */ './components/Parameter/List.vue')
const ListUpdateParameter = () => import(/* webpackChunkName: "component-CustomerList" */ './components/Parameter/ListUpdate.vue')
const EditDataParameter = () => import(/* webpackChunkName: "component-CustomerList" */ './components/Parameter/EditData.vue')
const Basp = () => import(/* webpackChunkName: "view-Customer" */ './views/Basp.vue')
const BaspList = () => import(/* webpackChunkName: "view-Customer" */ './components/Basp/List.vue')
const BaspCreate = () => import(/* webpackChunkName: "view-Customer" */ './components/Basp/Create.vue')
const Customer = () => import(/* webpackChunkName: "view-Customer" */ './views/Customer.vue')
const CustomerList = () => import(/* webpackChunkName: "component-CustomerList" */ './components/Customer/List.vue')
const CustomerCreate = () => import(/* webpackChunkName: "component-CustomerCreate" */ './components/Customer/Create/index.vue')

const Transporter = () => import(/* webpackChunkName: "view-Transporter" */ './views/Transporter.vue')
const TransporterList = () => import(/* webpackChunkName: "component-TransporterList" */ './components/Transporter/List.vue')
const TransporterCreate = () => import(/* webpackChunkName: "component-TransporterCreate" */ './components/Transporter/Create/index.vue')

const TransportType = () => import(/* webpackChunkName: "view-TransportType" */ './views/TransportType.vue')
const TransportTypeList = () => import(/* webpackChunkName: "component-TransportTypeList" */ './components/TransportType/List.vue')
const TransportTypeCreate = () => import(/* webpackChunkName: "component-TransportTypeCreate" */ './components/TransportType/Create.vue')

const AdditionalCost = () => import(/* webpackChunkName: "view-AdditionalCost" */ './views/AdditionalCost.vue')
const AdditionalCostList = () => import(/* webpackChunkName: "component-AdditionalCostList" */ './components/AdditionalCost/List.vue')

const Locations = () => import(/* webpackChunkName: "view-Locations" */ './views/Locations.vue')
const LocationList = () => import(/* webpackChunkName: "component-LocationsList" */ './components/Locations/List.vue')
const LocationCreate = () => import(/* webpackChunkName: "component-LocationsCreate" */ './components/Locations/Create.vue')

const SelectionInfo = () => import(/* webpackChunkName: "view-SelectionInfo" */ './views/SelectionInfo.vue')
const SelectionInfoList = () => import(/* webpackChunkName: "component-SelectionInfoList" */ './components/SelectionInfo/List.vue')

const Categories = () => import(/* webpackChunkName: "view-Categories" */ './views/Categories.vue')
const CategoryList = () => import(/* webpackChunkName: "component-CategoriesList" */ './components/Categories/List.vue')
const CategoryCreate = () => import(/* webpackChunkName: "component-CategoriesCreate" */ './components/Categories/Create.vue')

const Schedule = () => import(/* webpackChunkName: "view-Schedule" */ './views/Schedule.vue')

const ShippingProblem = () => import(/* webpackChunkName: "view-ShippingProblem" */ './views/ShippingProblem.vue')
const ShippingProblemDetail = () => import(/* webpackChunkName: "view-ShippingProblemDetail" */ './views/ShippingProblemDetail.vue')

const Report = () => import(/* webpackChunkName: "view-Report" */ './views/Report.vue')
const ReportList = () => import(/* webpackChunkName: "component-ReportList" */ './components/Report/List.vue')
const ReportParameter = () => import(/* webpackChunkName: "component-ReportParameter" */ './components/Report/Parameter.vue')
const ReportTransporter = () => import(/* webpackChunkName: "component-ReportTransporterListTransporter" */ './components/Report/ReportTransporter/ListTransporter/index.vue')
const ReportCustomer = () => import(/* webpackChunkName: "component-ReportCustomerListCustomer" */ './components/Report/ReportCustomer/ListCustomer/index.vue')
const ReportBasp = () => import(/* webpackChunkName: "component-ReportBASPListBASP" */ './components/Report/ReportBASP/ListBASP/index.vue')
const ReportRating3PL = () => import(/* webpackChunkName: "component-ReportRatingList3PL" */ './components/Report/ReportRating/List3PL/index.vue')
const ReportRating3PLDetail = () => import(/* webpackChunkName: "component-ReportRatingListDetail3PL" */ './components/Report/ReportRating/ListDetail3PL/index.vue')
const ReportRating3PLOrder = () => import(/* webpackChunkName: "component-ReportRatingListOrder" */ './components/Report/ReportRating/ListOrder/index.vue')
const ReportCategory = () => import(/* webpackChunkName: "component-ReportCategoryShipmentListCategory" */ './components/Report/ReportCategoryShipment/ListCategory/index.vue')
const ReportCategoryOrder = () => import(/* webpackChunkName: "component-ReportCategoryShipmentListOrder" */ './components/Report/ReportCategoryShipment/ListOrder/index.vue')
const ReportRitase = () => import(/* webpackChunkName: "component-ReportRitaseShipmentListRitase" */ './components/Report/ReportRitaseShipment/ListRitase/index.vue')
const ReportRitaseOrder = () => import(/* webpackChunkName: "component-ReportRitaseShipmentListOrder" */ './components/Report/ReportRitaseShipment/ListOrder/index.vue')

const ReportCustomerInvoice = () => import(/* webpackChunkName: "component-ReportCustomerInvoice" */ './components/Report/ReportCustomerInvoice/index.vue')
const ReportTransporterInvoice = () => import(/* webpackChunkName: "component-ReportTransporterInvoice" */ './components/Report/ReportTransporterInvoice/index.vue')
const ReportAging = () => import(/* webpackChunkName: "component-ReportAging" */ './components/Report/ReportAging/index.vue')
const ReportAgingTo3PL = () => import(/* webpackChunkName: "component-ReportAgingTo3PL" */ './components/Report/ReportAgingTo3PL/index.vue')
const ReportIncome = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportIncome/index.vue')
const ReportDataArmada = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportDataArmada/index.vue')
const ReportOrderShipper = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportOrderShipper/index.vue')

const Tax = () => import(/* webpackChunkName: "view-Tax" */ './views/Tax.vue')
const TaxList = () => import(/* webpackChunkName: "component-TaxList" */ './components/Tax/List.vue')

const DamagedAndMissing = () => import(/* webpackChunkName: "view-DamagedAndMissing" */ './views/DamagedAndMissing.vue')

const Invoice = () => import(/* webpackChunkName: "view-Invoice" */ './views/Invoice.vue')
const Invoicelist = () => import(/* webpackChunkName: "component-InvoiceList" */ './components/Invoice/List.vue')
const InvoiceCreate = () => import(/* webpackChunkName: "component-InvoiceCreate" */ './components/Invoice/Create.vue')

const UserAdmin = () => import(/* webpackChunkName: "view-UserAdmin" */ './views/UserAdmin.vue')
const UserAdminList = () => import(/* webpackChunkName: "component-UserAdminList" */ './components/UserAdmin/List.vue')
const UserAdminCreate = () => import(/* webpackChunkName: "component-UserAdminCreate" */ './components/UserAdmin/Create.vue')

const InvoiceData = () => import(/* webpackChunkName: "view-InvoiceData" */ './views/InvoiceData.vue')
const InvoiceDataForm = () => import(/* webpackChunkName: "component-InvoiceDataForm" */ './components/InvoiceData/Form.vue')

const About = () => import(/* webpackChunkName: "view-About" */ './views/About.vue')
const ContactUs = () => import(/* webpackChunkName: "view-ContactUs" */ './views/ContactUs.vue')

Vue.use(Router)

const AuthGuard = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    store.dispatch('user/fetchMyInfo')
      .then(res => {
        if (to.meta.action && !store.getters['user/isAllowed'](to.meta.action)) throw new Error('not allowed')
        return next()
      })
      .catch(err => {
        if (err.message === 'not allowed') {
          Vue.prototype.$message.error(Vue.prototype.$_strings.messages.errors.noAccess)
          return next('/welcome/login')
        }
      })
      .finally(e => {
      })
  } else {
    next('/welcome/login')
  }
}

const loginPageGuard = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next('/main')
  } else {
    next()
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/main',
      component: MainLayout,
      title: 'Main',
      children: [
        {
          path: '',
          redirect: '/main/dashboard'
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          beforeEnter: AuthGuard,
          component: Dashboard,
          meta: {
            title: 'Dashboard',
            action: 'ORDERS_VIEW',
          }
        },
        {
          path: 'order-detail/:orderId',
          name: 'Order Detail',
          beforeEnter: AuthGuard,
          component: OrderDetail,
          meta: {
            title: 'Rincian Pesanan',
            action: 'ORDERS_DETAIL_VIEW',
          }
        },
        {
          path: 'shipping-problem',
          name: 'Shipping Problem',
          beforeEnter: AuthGuard,
          component: ShippingProblem,
          meta: {
            title: 'Masalah Pengiriman',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'shipping-problem/:orderId',
          name: 'Shipping Problem Detail',
          beforeEnter: AuthGuard,
          component: ShippingProblemDetail,
          meta: {
            title: 'Detil Masalah Pengiriman',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'damaged-and-missing',
          name: 'Damaged And Missing',
          beforeEnter: AuthGuard,
          component: DamagedAndMissing,
          meta: {
            title: 'Kerusakan Dan Kekurangan',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'orders',
          redirect: 'orders/waiting'
        },
        {
          path: 'orders/:tab',
          name: 'Orders',
          beforeEnter: AuthGuard,
          component: Orders,
          meta: {
            title: 'Pesanan',
            action: 'ORDERS_VIEW',
          }
        },
        {
          path: 'schedule',
          name: 'Schedule',
          beforeEnter: AuthGuard,
          component: Schedule,
          meta: {
            title: 'Jadwal',
            action: 'SCHEDULE_VIEW',
          }
        },
        {
          path: 'invoice-shipper/',
          component: Invoice,
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: 'Invoice Customer List',
              beforeEnter: AuthGuard,
              component: Invoicelist,
              meta: {
                invoiceClientType: 'shipper',
                title: 'Invoice List',
                action: 'INVOICE_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Invoice Create',
              beforeEnter: AuthGuard,
              component: InvoiceCreate,
              meta: {
                invoiceClientType: 'shipper',
                title: 'Buat Invoice',
                action: 'INVOICE_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Invoice Edit',
              beforeEnter: AuthGuard,
              component: InvoiceCreate,
              meta: {
                invoiceClientType: 'shipper',
                title: 'Ubah Invoice',
                action: 'INVOICE_UPDATE',
              }
            },
          ]
        },
        {
          path: 'invoice-transporter/',
          component: Invoice,
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: 'Invoice 3PL List',
              beforeEnter: AuthGuard,
              component: Invoicelist,
              meta: {
                invoiceClientType: 'transporter',
                title: 'Invoice List',
                action: 'INVOICE_VIEW',
              }
            },
          ]
        },
        {
          path: 'parameter',
          component: Parameter,
          children: [
            {
              path: '',
              redirect: '/main/parameter/list'
            },
            {
              path: 'list',
              name: 'Parameter List',
              beforeEnter: AuthGuard,
              component: ParameterList,
              meta: {
                title: 'Parameter List',
                action: 'PARAMETER_VIEW',
              }
            },
            {
              path: 'list-update/:id/:parameterName',
              name: 'List Parameter Update',
              beforeEnter: AuthGuard,
              component: ListUpdateParameter,
              meta: {
                title: 'List Update Parameter',
                action: 'PARAMETER_UPDATE',
              },
            },
            {
              path: 'list-update/edit-data',
              name: 'Edit Data Parameter',
              beforeEnter: AuthGuard,
              component: EditDataParameter,
              meta: {
                name: 'Edit Data Parameter',
                action: 'PARAMETER_UPDATE',
              }
            }
          ]
        },
        {
          path: 'basp',
          component: Basp,
          children: [
            {
              path: '',
              redirect: '/main/basp/list'
            },
            {
              path: 'list',
              name: 'Basp List',
              beforeEnter: AuthGuard,
              component: BaspList,
              meta: {
                title: 'Basp List',
                action: 'BASP_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Basp Create',
              beforeEnter: AuthGuard,
              component: BaspCreate,
              meta: {
                title: 'Basp Create',
                action: 'BASP_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Basp Update',
              beforeEnter: AuthGuard,
              component: BaspCreate,
              meta: {
                title: 'Basp Update',
                action: 'BASP_UPDATE',
              }
            },
          ]
        },
        {
          path: 'customer',
          component: Customer,
          children: [
            {
              path: '',
              redirect: '/main/customer/list'
            },
            {
              path: 'list',
              name: 'Customer List',
              beforeEnter: AuthGuard,
              component: CustomerList,
              meta: {
                title: 'Customer List',
                action: 'CUSTOMERS_VIEW',
              }
            },
            {
              path: 'create/',
              redirect: '/main/customer/create/company-profile'
            },
            {
              path: 'create/:step',
              name: 'Customer Create',
              beforeEnter: AuthGuard,
              component: CustomerCreate,
              meta: {
                title: 'Buat Customer',
                action: 'CUSTOMERS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              redirect: '/main/customer/edit/:id/company-profile'
            },
            {
              path: 'edit/:id/:step',
              name: 'Customer Edit',
              beforeEnter: AuthGuard,
              component: CustomerCreate,
              meta: {
                title: 'Ubah Customer',
                action: 'CUSTOMERS_EDIT',
              }
            }
          ]
        },
        {
          path: 'transporter',
          component: Transporter,
          children: [
            {
              path: '',
              redirect: '/main/transporter/list',
            },
            {
              path: 'list',
              name: 'Transporter List',
              beforeEnter: AuthGuard,
              component: TransporterList,
              meta: {
                title: 'Rekanan 3PL',
                action: 'TRANSPORTERS_VIEW',
              }
            },
            {
              path: 'create/',
              redirect: '/main/transporter/create/company-profile'
            },
            {
              path: 'create/:step',
              name: 'Transporter Create',
              beforeEnter: AuthGuard,
              component: TransporterCreate,
              meta: {
                title: 'Buat Rekanan 3PL',
                action: 'TRANSPORTERS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              redirect: '/main/transporter/edit/:id/company-profile'
            },
            {
              path: 'edit/:id/:step',
              name: 'Transporter Edit',
              beforeEnter: AuthGuard,
              component: TransporterCreate,
              meta: {
                title: 'Ubah Rekanan 3PL',
                action: 'TRANSPORTERS_EDIT',
              }
            }
          ]
        },
        {
          path: 'transport-type',
          component: TransportType,
          children: [
            {
              path: '',
              redirect: '/main/transport-type/list',
            },
            {
              path: 'list',
              name: 'Transport Types',
              beforeEnter: AuthGuard,
              component: TransportTypeList,
              meta: {
                title: 'Tipe Kendaraan',
                action: 'TRANSPORT_TYPES_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Transport Type Create',
              beforeEnter: AuthGuard,
              component: TransportTypeCreate,
              meta: {
                title: 'Buat Tipe Kendaraan',
                action: 'TRANSPORT_TYPES_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Transport Type Edit',
              beforeEnter: AuthGuard,
              component: TransportTypeCreate,
              meta: {
                title: 'Ubah Tipe Kendaraan',
                action: 'TRANSPORT_TYPES_EDIT',
              }
            }
          ]
        },
        {
          path: 'additional-cost',
          component: AdditionalCost,
          children: [
            {
              path: '',
              redirect: '/main/additional-cost/list',
            },
            {
              path: 'list',
              name: 'Additional Cost',
              beforeEnter: AuthGuard,
              component: AdditionalCostList,
              meta: {
                title: 'Biaya Tambahan',
                action: 'ADDITIONALCOSTS_VIEW',
              }
            },
          ]
        },
        {
          path: 'locations',
          component: Locations,
          children: [
            {
              path: '',
              redirect: '/main/locations/list',
            },
            {
              path: 'list',
              name: 'Locations',
              beforeEnter: AuthGuard,
              component: LocationList,
              meta: {
                title: 'Lokasi',
                action: 'LOCATIONS_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Locations Create',
              beforeEnter: AuthGuard,
              component: LocationCreate,
              meta: {
                title: 'Buat Lokasi',
                action: 'LOCATIONS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Locations Edit',
              beforeEnter: AuthGuard,
              component: LocationCreate,
              meta: {
                title: 'Ubah Lokasi',
                action: 'LOCATIONS_EDIT',
              }
            }
          ]
        },
        {
          path: 'selection-infos',
          component: SelectionInfo,
          children: [
            {
              path: '',
              redirect: '/main/selection-infos/list',
            },
            {
              path: 'list',
              name: 'Selection Info',
              beforeEnter: AuthGuard,
              component: SelectionInfoList,
              meta: {
                title: 'Pilihan dan Alasan',
                action: 'SELECTIONITEMS_VIEW',
              }
            },
          ]
        },
        {
          path: 'categories',
          component: Categories,
          children: [
            {
              path: '',
              redirect: '/main/categories/list',
            },
            {
              path: 'list',
              name: 'Category List',
              beforeEnter: AuthGuard,
              component: CategoryList,
              meta: {
                title: 'Kategori',
                action: 'CATEGORIES_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Category Create',
              beforeEnter: AuthGuard,
              component: CategoryCreate,
              meta: {
                title: 'Buat Kategori',
                action: 'CATEGORIES_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Category Edit',
              beforeEnter: AuthGuard,
              component: CategoryCreate,
              meta: {
                title: 'Ubah Kategori',
                action: 'CATEGORIES_EDIT',
              }
            }
          ]
        },
        {
          path: 'report',
          component: Report,
          children: [
            {
              path: 'list',
              name: 'Report List',
              beforeEnter: AuthGuard,
              component: ReportList,
              meta: {
                title: 'Daftar Laporan',
                action: 'ORDERS_VIEW',
              }
            },
            {
              path: ':id',
              name: 'Report Parameter',
              beforeEnter: AuthGuard,
              component: ReportParameter,
              meta: {
                title: 'Parameter Laporan',
                action: 'ORDERS_VIEW',
              },
            },
            {
              path: '1/list',
              name: 'Report Transporter',
              beforeEnter: AuthGuard,
              component: ReportTransporter,
              meta: {
                title: 'Detil Laporan Transporter',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '2/list',
              name: 'Report Basp',
              beforeEnter: AuthGuard,
              component: ReportBasp,
              meta: {
                title: 'Detil Laporan Basp',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '3/list',
              name: 'Report Customer',
              beforeEnter: AuthGuard,
              component: ReportCustomer,
              meta: {
                title: 'Detil Laporan Customer',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '4/list',
              name: 'Report Rating 3PL',
              beforeEnter: AuthGuard,
              component: ReportRating3PL,
              meta: {
                title: 'Laporan Rating 3PL',
                action: 'ORDERS_VIEW'
              },
              props: true,
            },
            {
              path: '4/list/:option/:idClient',
              name: 'Report Rating Detail',
              beforeEnter: AuthGuard,
              component: ReportRating3PLDetail,
              meta: {
                title: 'Detil Laporan Rating 3PL',
                action: 'ORDERS_VIEW'
              },
            },
            {
              path: '4/list/:option/:idClient/order',
              name: 'Report Rating Detail Order',
              beforeEnter: AuthGuard,
              component: ReportRating3PLOrder,
              meta: {
                title: 'Detil Laporan Rating 3PL',
                action: 'ORDERS_VIEW'
              },
            },
            {
              path: '5/list',
              name: 'Report Order By Category',
              beforeEnter: AuthGuard,
              component: ReportCategory,
              meta: {
                title: 'Detil Laporan Pesanan Berdasarkan Kategori',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '5/list/detail',
              name: 'Report Detail Order By Category',
              beforeEnter: AuthGuard,
              component: ReportCategoryOrder,
              meta: {
                title: 'Detil Laporan Pesanan Berdasarkan Kategori',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '6/list',
              name: 'Report Order By Ritase',
              beforeEnter: AuthGuard,
              component: ReportRitase,
              meta: {
                title: 'Laporan Pesanan Berdasarkan Ritase',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '6/list/detail',
              name: 'Report Detail Order By Ritase',
              beforeEnter: AuthGuard,
              component: ReportRitaseOrder,
              meta: {
                title: 'Detil Laporan Pesanan Berdasarkan Ritase',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '7/list',
              name: 'Report Order By Shipper',
              beforeEnter: AuthGuard,
              component: ReportOrderShipper,
              meta: {
                title: 'Laporan Pesanan Shipper Per Status',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '8/list',
              name: 'Report Data Armada and Driver',
              beforeEnter: AuthGuard,
              component: ReportDataArmada,
              meta: {
                title: 'Laporan Data Armada dan Driver',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '9/list',
              name: 'Report Invoice By Customer',
              beforeEnter: AuthGuard,
              component: ReportCustomerInvoice,
              meta: {
                title: 'Laporan Tagihan Customer',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '10/list',
              name: 'Report Aging',
              beforeEnter: AuthGuard,
              component: ReportAging,
              meta: {
                title: 'Laporan Aging',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '11/list',
              name: 'Report Income',
              beforeEnter: AuthGuard,
              component: ReportIncome,
              meta: {
                title: 'Laporan Estimasi Pendapatan',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '13/list',
              name: 'Report Invoice By Transporter',
              beforeEnter: AuthGuard,
              component: ReportTransporterInvoice,
              meta: {
                title: 'Laporan Tagihan Transporter',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '14/list',
              name: 'Report Aging Hutang ke 3PL',
              beforeEnter: AuthGuard,
              component: ReportAgingTo3PL,
              meta: {
                title: 'Report Aging Hutang ke 3PL',
                action: 'ORDERS_VIEW'
              }
            },
          ]
        },
        {
          path: 'user-admin',
          component: UserAdmin,
          children: [
            {
              path: '',
              redirect: '/main/user-admin/list',
            },
            {
              path: 'list',
              name: 'User Admin List',
              beforeEnter: AuthGuard,
              component: UserAdminList,
              meta: {
                title: 'List User Admin',
                action: 'USERADMINS_VIEW',
              }
            },
            {
              path: 'create',
              name: 'User Admin Create',
              beforeEnter: AuthGuard,
              component: UserAdminCreate,
              meta: {
                title: 'Buat User Admin',
                action: 'USERADMINS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'User Admin Edit',
              beforeEnter: AuthGuard,
              component: UserAdminCreate,
              meta: {
                title: 'Ubah User Admin',
                action: 'USERADMINS_EDIT',
              }
            }
          ]
        },
        {
          path: 'invoice-data',
          component: InvoiceData,
          children: [
            {
              path: '',
              redirect: '/main/invoice-data/form',
            },
            {
              path: 'form',
              name: 'Invoice Data Form',
              beforeEnter: AuthGuard,
              component: InvoiceDataForm,
              meta: {
                title: 'Invoice Data Form',
                action: 'INVOICEDATA_VIEW',
              }
            },
          ]
        },
        {
          path: 'tax/',
          component: Tax,
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: 'Tax List',
              beforeEnter: AuthGuard,
              component: TaxList,
              meta: {
                invoiceClientType: 'shipper',
                title: 'Pajak (e-Faktur)',
                action: 'TAX_VIEW',
              }
            }
          ]
        },
        {
          path: 'about',
          name: 'About',
          beforeEnter: AuthGuard,
          component: About,
          meta: {
            title: 'Tentang Kami',
          }
        },
        {
          path: 'contact-us',
          name: 'contact-us',
          beforeEnter: AuthGuard,
          component: ContactUs,
          meta: {
            title: 'Hubungi Kami',
          }
        },
      ]
    },
    {
      path: '/welcome',
      component: Welcome,
      beforeEnter: loginPageGuard,
      children: [
        {
          path: '',
          redirect: '/welcome/login'
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            title: 'Masuk'
          }
        },
        {
          path: 'verification',
          name: 'email-verification',
          component: EmailVerification,
          meta: {
            title: 'Verifikasi Email'
          }
        },
        {
          path: 'activation',
          name: 'activation',
          component: Activation,
          meta: {
            title: 'Aktifasi Akun'
          }
        }
      ]
    },
    {
      path: '*',
      beforeEnter: AuthGuard,
      redirect: '/main/dashboard'
    }
  ]
})

router.beforeResolve((to, from, next) => {
  document.title = to.meta.title || 'FLI Admin Dashboard'
  next()
})

export default router
